<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="网点名称"
        >
          <a-input
            placeholder="请输入网点名称"
            :max-length="16"
            v-decorator="['name', validatorRules.name]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="官网网址"
        >
          <a-input
            placeholder="请输入官网网址"
            :max-length="16"
            v-decorator="['web', validatorRules.web]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="网点电话"
        >
          <a-input
            placeholder="请输入网点电话"
            :max-length="16"
            v-decorator="['mobile', validatorRules.mobile]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { saveOrganization } from '@/api/organization.js';
export default {
  data() {
    return {
      title: '新增',
      visible: false,
      confirmLoading: false,
      // model:'year',
      model: {},
      typeText: '',
      value: '',
      yearPick: null,
      yearPickShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        web: {
          rules: [
            {
              required: true,
              message: '请输入正确的官网网址!',
              pattern: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
            }
          ]
        },
        name: { rules: [{ required: true, message: '请输入网点名称!' }] },
        // sex: { rules: [{ required: true, message: '请选择性别!' }] },
        mobile: {
          rules: [
            {
              required: true,
              message: '请输入正确的网点电话!',
              pattern: '^[0-9]*$'
            }
          ]
        }
      },
      url: {
        add:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productsOrganization/add',
        edit:
          process.env.VUE_APP_CMS_PRODUCT + '/product/productsOrganization/edit'
      }
    };
  },
  components: {
    JDate,
    JDictSelectTag
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'web', 'name', 'mobile'));
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(this.model, values);
          saveOrganization(formData).then(res => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok');
            } else {
              that.$message.warning(res.message);
            }
            that.confirmLoading = false;
            that.close();
          });
        }
      });
    },
    handleCancel() {
      this.close();
    }
  }
};
</script>

<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
